package io.github.jangalinski.pages._2016._04._05

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initIdeaUltimateOnOsxPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("2016/04/05/IdeaUltimateOnOsx.md", FrontMatterElement.Builder { addScalar("title", "Intellij Idea Ultimate on OSX El Capitan"); addScalar("date", "2016-04-05"); }))
}

@Page("/2016/04/05/idea-ultimate-on-osx")
@Layout(".site.components.layout.BlogLayout")
@Composable
fun IdeaUltimateOnOsxPage() {
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Just got my new extended personal license for Intellij Idea 2016.1. Had some trouble getting it running because it now ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("requires")
        }
        org.jetbrains.compose.web.dom.Text(" Java8 while I could not get the previous version running ")
        org.jetbrains.compose.web.dom.Em {
            org.jetbrains.compose.web.dom.Text("with")
        }
        org.jetbrains.compose.web.dom.Text(" Java8.")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("So the first thing I had to do was googling around til I found this: ")
        com.varabyte.kobweb.silk.components.navigation.Link("https://jetbrains.com/help/idea/changing-runtime.html") {
            org.jetbrains.compose.web.dom.Text("Selecting the JDK version")
        }
        org.jetbrains.compose.web.dom.Text(".")
    }
    org.jetbrains.compose.web.dom.Pre { org.jetbrains.compose.web.dom.Code { org.jetbrains.compose.web.dom.Text("""echo "/Library/Java/JavaVirtualMachines/jdk1.8.0_66.jdk" > ~/Library/Preferences/IntelliJIdea2016.1/idea.jdk
""") } }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Now Idea will start with the set jdk no matter what my JAVA_HOME might be. Check!")
    }
}
